import axios from 'axios';
import { documentAddedReportApiUrl } from '@/GlobalConfig/app-config';


class DocumentAddedReportListService{
    
    constructor(){}
    readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
      }
      return null;
  }

    public async getDocumentAddedReportList(token:any) {
        const Url = documentAddedReportApiUrl;
        var csrftoken = this.readCookie('csrftoken');
       let header = {'Authorization': 'Token '+token,"X-CSRFToken":csrftoken};
        return axios({
          method: 'get',
          url: Url,
         headers: header
        });
      }
    public async getDocumentAddedReportListReportFilter(saveData:any,token:any){
      const Url = documentAddedReportApiUrl;
      var csrftoken = this.readCookie('csrftoken');
      let header = {'Authorization': 'Token '+token,"X-CSRFToken":csrftoken};
      return axios({
        method: 'post',
        url: Url,
        data: saveData,
        headers: header
      });
    }
}

export const documentAddedReportListService = new DocumentAddedReportListService();